import {createAction} from '@reduxjs/toolkit';

export const setAccountId = createAction<number>('SET_ACCOUNT_ID');
